export const ReadinessMeter = ({ percent = 0, hours = 0, goal = 7 }) => {
  const size = 240;
  const stroke = 14;
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const dash = (Math.min(percent, 100) / 100) * circumference;

  const color = percent >= 100 ? "#34D399" : percent >= 50 ? "#D4AF37" : "#FBBF24";

  return (
    <div className="relative inline-flex items-center justify-center" data-testid="readiness-meter">
      <svg width={size} height={size} className="-rotate-90">
        {/* track */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="rgba(255,255,255,0.06)"
          strokeWidth={stroke}
          fill="none"
        />
        {/* progress */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={color}
          strokeWidth={stroke}
          fill="none"
          strokeDasharray={`${dash} ${circumference}`}
          strokeLinecap="round"
          style={{ transition: "stroke-dasharray 0.8s ease, stroke 0.4s ease", filter: `drop-shadow(0 0 8px ${color}88)` }}
        />
        {/* hash marks */}
        {Array.from({ length: 7 }).map((_, i) => {
          const angle = (i / 7) * 2 * Math.PI - Math.PI / 2;
          const inner = radius - stroke / 2 - 6;
          const outer = radius - stroke / 2 + 6;
          const x1 = size / 2 + Math.cos(angle) * inner;
          const y1 = size / 2 + Math.sin(angle) * inner;
          const x2 = size / 2 + Math.cos(angle) * outer;
          const y2 = size / 2 + Math.sin(angle) * outer;
          return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="rgba(255,255,255,0.2)" strokeWidth="1" />;
        })}
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
        <div className="hud-label text-[10px] mb-1">Op Readiness</div>
        <div className="font-display text-5xl text-white font-light" data-testid="readiness-percent">
          {Math.min(100, Math.round(percent))}<span className="text-gold text-2xl">%</span>
        </div>
        <div className="text-xs text-slate-400 mt-1 font-mono-aviation" data-testid="readiness-hours">
          {hours.toFixed(2)}<span className="opacity-50"> / {goal}h</span>
        </div>
      </div>
    </div>
  );
};
